export default __webpack_public_path__ + "static/media/sunny.889b8446.webp";